import { Link } from 'react-router-dom';
import MedboxLogo from '@/assets/icons/medbox-footer-logo.png';
import PrivacyChoices from '@/assets/images/privacy-choices.png';
import NABPLogo from '@/assets/icons/dashboard/footer/nabp.png';

const links = [
    { label: 'Privacy Policy', link: 'https://medbox.com/privacy-policy/' },
    { label: 'Terms of Use', link: 'https://medbox.com/terms-of-use/' },
    { label: 'Cookie Policy', link: 'https://medbox.com/cookie-policy/' },
    // { label: 'Practices Child', link: '' },
    { label: 'Notice of Privacy Practices', link: 'https://medbox.com/notice-of-privacy-practices/' },
    { label: 'Child Safety Waiver', link: 'https://medbox.com/child-safety-waiver/' },
    { label: 'Privacy Choices', link: '#', external: true, customClass: 'cky-banner-element', img: PrivacyChoices },
];

const logos = [
    // { logo: AmFasterstGrowingLogo, link: '', sizes: 'w-[52px] h-[52px]' },
    {
        logo: 'https://static.legitscript.com/seals/400488.png',
        link: 'https://www.legitscript.com/websites/?checker_keywords=medbox.com',
        sizes: 'w-[60px] h-[52px]'
    },
    {
        logo: NABPLogo,
        link: 'https://app.us.openbadges.me/view/#!/badge?badgeid=18c10173-c11c-4ee9-8b56-fee4dbf5c1af',
        sizes: 'w-[106px] h-[52px]'
    }
];

const Footer = () => {
    return (
        <footer className="mb-[62px] h-full w-full bg-primary-800 px-5 pb-7 pt-8 font-atkinsonHyperlegible text-sm text-mint-400 sm:mb-[70px] md:mb-[74px] lg:mb-0 lg:px-[50px] lg:pt-9 xl:px-[70px]">
            <div className="flex w-full flex-col">
                <div className="flex w-full items-end justify-between border-primary-700 pb-4 lg:border-b lg-max:border-t lg-max:pt-5 font-atkinson text-12">
                    <img className="hidden w-full lg:block lg:max-w-[140px] xl:max-w-[168px]" src={MedboxLogo} alt="MedBox logo" />
                    <div className="flex flex-wrap items-center gap-[15px] justify-start">
                        {links.map(link => {
                            if (link.external) {
                                return (
                                    <a
                                        href={link.link}
                                        key={link.label}
                                        className={`border-b border-transparent hover:border-current inline-flex items-center gap-1 ${link.customClass || ''}`}
                                    >
                                        <span>{link.label}</span>
                                        {link.img && (
                                            <img src={link.img} alt="" className="w-[22px] h-[12px]" />
                                        )}
                                    </a>
                                );
                            }

                            return (
                                <Link
                                    to={link.link}
                                    key={link.label}
                                    className="border-b border-transparent hover:border-current"
                                    target="_blank"
                                >
                                    {link.label}
                                </Link>
                            );
                        })}

                    </div>
                </div>

                <div className="flex items-center justify-between gap-5 py-4 lg-max:flex-col-reverse lg-max:items-start lg-max:justify-start lg-max:pb-1 lg-max:pt-2">
                    <img className="block lg:hidden" src={MedboxLogo} alt="MedBox logo" />
                    <span>
                        <span className='text-14'>© 2025 MedBox by AmeriPharma. All Rights Reserved.</span>

                        <br />
                        MedBox is an AmeriPharma company. AmeriPharma's premier services are available in 40+ US states and territories.
                    </span>

                    <div className="flex items-center gap-5">
                        {logos.map((item, i) => (
                            <Link to={item.link} target="_blank" key={'link-' + i}>
                                <img src={item.logo} alt={item.logo} className={`${item.sizes}`} />
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
